<template>
  <v-row>
    <v-col cols="12">
      <v-form>
        <v-card>
          <v-card-title>Whatsapp Gateway</v-card-title>
          <v-card-subtitle v-if="qr != null">
            Silahkan scan QRCode berikut
          </v-card-subtitle>

          <v-card-text>
            <v-row style="min-height: 200px" align="center" justify="center">
              <template v-if="qr != null">
                <div class="pa-5">
                  <img :src="qr" alt="" style="width: 400px; max-width: 100%" />
                </div>
              </template>

              <template v-else-if="isConnected">
                <div>Whatsapp sudah terhubung.</div>
              </template>

              <template v-else>
                <div>Memuat...</div>
              </template>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { socket } from "../../plugins/io";

export default {
  data() {
    return {
      isConnected: false,
      qr: null,
    };
  },
  created() {
    this.checkGateway();
  },
  methods: {
    checkGateway() {
      socket.on("connection", (s) => {
        console.log("connected to socket server");
      });

      socket.on("qr", (qr) => {
        this.qr = qr;
      });

      socket.on("qr-connected", (res) => {
        this.isConnected = true;
      });
    },
  },
};
</script>
